import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-offline-info',
    templateUrl: './offline-info.component.html',
    styleUrls: ['./offline-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass]
})
export class OfflineInfoComponent implements OnInit {

@Input() iconClass = '';
@Input() text = '';
@Input() showInfo = false;

constructor() { }

ngOnInit() {

}

}
